import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/5.png";
import "./Nav.css";

const Nav = ({url}) => {
  return (
    <div className="h-[100px] pr-[30px] flex items-center justify-between bg-white sm:h-[150px] sm:pr-[80px] overflow-y-hidden">
      <div className="nav-logo">
        <img src={Logo} alt="logo" />
      </div>
      <Link to={url}>
        <button className="small-btn font-medium">Sign Up</button>
      </Link>
    </div>
  );
};

export default Nav;
